'use client';

import { useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from '@phosphor-icons/react/dist/ssr';
import { Button } from '@/shared/ui/core';
import {
    RegistrationCard, RegistrationCardContent, RegistrationCardDescription, RegistrationCardHeader,
    RegistrationCardTitle,
} from '@/shared/ui/layout/registration-card';
import { PlanPicker, type PlanPickerValue } from '@/features/subscription-plan-picker';
import { useWizard } from '../../model/wizard-context';
import { WizardFooter } from '../wizard-footer';
import styles from './step-plan.module.scss';


const DEFAULT_VALUE: PlanPickerValue = {
    billing_period: 'monthly',
    plan_id       : '',
};


export const StepPlan = () => {
    const { state, dispatch } = useWizard();

    const [ value, setValue ] = useState<PlanPickerValue>(state.data.plan ?? DEFAULT_VALUE);
    const [ error, setError ] = useState<string>();

    const handleChange = (next: PlanPickerValue) => {
        setValue(next);
        if (next.plan_id) setError(undefined);
    };

    const handleNext = () => {
        if (!value.plan_id) {
            setError('Please select a plan');
            return;
        }
        dispatch({ type: 'commit', key: 'plan', value });
        dispatch({ type: 'next' });
    };

    const handleBack = () => {
        dispatch({ type: 'commit', key: 'plan', value });
        dispatch({ type: 'back' });
    };

    return (
        <div>
            <RegistrationCard data-template="registration-steps-card">
                <RegistrationCardHeader data-template="registration-steps-card-header">
                    <RegistrationCardTitle data-template="registration-steps-card-title">
                        {
                            'Hello{{name}}! Let’s choose your subscription plan'.replace(
                                '{{name}}',
                                state.data.profile?.first_name ? (', ' + state.data.profile?.first_name) : ''
                            )
                        }
                    </RegistrationCardTitle>

                    <RegistrationCardDescription data-template="registration-steps-card-description">
                        Flexible options for any size of business.
                    </RegistrationCardDescription>
                </RegistrationCardHeader>

                <RegistrationCardContent data-template="registration-steps-card-content">
                    <div data-template="step-plan" className={ styles.root }>
                        <PlanPicker
                            value={ value }
                            onChange={ handleChange }
                            error={ error }
                        />
                    </div>

                </RegistrationCardContent>
            </RegistrationCard>

            <WizardFooter
                state={ state }
                left={
                    <Button
                        onClick={ handleBack }
                        leftIcon={ <ArrowLeftIcon/> }
                        variant="secondary"
                    >
                        Back
                    </Button>
                }
                right={
                    <Button
                        onClick={ handleNext }
                        leftIcon={ <ArrowRightIcon/> }
                    >
                        Continue
                    </Button>
                }
            />
        </div>
    );
};
